export default __webpack_public_path__ + "static/media/enragingstrike2.7c1bbfe9.png";